import store from '@/state/store'
import {AccountStatus, SessionLoginState} from '@/enums'

export default [
	{
		path: '',
		name: 'index',
		meta: {
			login_required: false,
			beforeResolve(routeTo, routeFrom, next) {
				next({name: 'applications'});
			},
		},
	},
	{
		path: '/documentation/data-api',
		name: 'documentation_dataapi',
		component: () => import('@/router/view/documentation/data_api'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/documentation/hephaistos',
		name: 'documentation_hephaistos',
		component: () => import('@/router/view/documentation/hephaistos'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/documentation/gamelabs/dayz',
		name: 'documentation_gamelabs_dayz',
		component: () => import('@/router/view/documentation/gamelabs'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/documentation/public-api/geo',
		name: 'documentation_geo_api',
		component: () => import('@/router/view/documentation/geo_api'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/documentation/public-api/convert',
		name: 'documentation_convert_api',
		component: () => import('@/router/view/documentation/convert_api'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/etc/assets',
		name: 'assets',
		component: () => import('@/router/view/etc/assets'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/enterprise-api',
		name: 'enterprise_api',
		component: () => import('@/router/view/enterprise_api/view'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/applications',
		name: 'applications',
		component: () => import('@/router/view/applications/index'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/application/:application_id',
		name: 'application',
		component: () => import('@/router/view/applications/view'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/gamelabs/workshop',
		name: 'workshop',
		component: () => import('@/router/view/workshop/index'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/gamelabs/workshop/:file_id',
		name: 'workshop_item',
		component: () => import('@/router/view/workshop/view'),
		meta: {
			login_required: true
		},
	},
	{
		path: '/logout',
		name: 'logout',
		meta: {
			auth_required: true,
			beforeResolve(routeTo, routeFrom, next) {
				fetch(process.env.VUE_APP_ROOT_API + 'v1/@me/acsrf-token', {credentials: 'include'})
				.then(response => {
					if (response.ok) {
						return response.json();
					}
				})
				.then(data => {
					console.log(data);
					/* Actual request */
					let payload = {
						acsrf_token: data.acsrf_token
					};
					fetch(process.env.VUE_APP_ROOT_API + 'v1/@me/logout', {
						method: 'POST',
						body: JSON.stringify(payload),
						credentials: 'include'
					})
					.then(response => {
						if (response.ok) {
							return response.json();
						}
					})
					.then(data => {
						console.log('Logging out...');
						store.commit('actionLogout');
						location.reload();
					})
					.catch(error => {
						console.log(error);
					});
					/* --- */
				})
				.catch(error => {
					console.log(error);
				});
			},
		},
	},
	{
		path: '*',
		name: 'not-found',
		component: () => import('@/router/view/errors/404'),
		meta: {
			auth_required: false
		}
	}
]
